import { configureStore } from '@reduxjs/toolkit'
import blocksReducer from './blocksReducer'

const store = configureStore({
  reducer: {
    blocks: blocksReducer
  }
})

export default store
